import { PatientProps } from './patient.props';
import {
  PatientOrderSummaryOrganism,
  PromoBoxOrganism,
  PatientSubscriptionSummaryOrganism,
  PatientStepsOrganism,
} from '../../organisms';
import { useSelector } from 'react-redux';
import { CartState, StoreState } from '../../../services';
import React from 'react';
import { cartPromoBox } from '../../../data/pages/cart/cart-promo-box';
import { useResponsiveQuery } from '../../../utils';
import { ResponsiveSizes } from '../../../enums';

export const PatientTemplate = (props: PatientProps) => {
  const { cart, includesDrops, includesTrial } = useSelector(
    (state: StoreState) => state.orders.cart
  ) as CartState;
  const isBreakpoint = useResponsiveQuery(ResponsiveSizes.CHECKOUT_DESKTOP);
  return (
    <div className="flex">
      <div className="z-10 mt-20 mb-20 w-full max-w-screen-xl mx-auto md:px-5">
        <div className="md:flex">
          <div className="w-full lg:w-3/5 pr-0 lg:pr-16">
            <PatientStepsOrganism active={props.active} />
            {props.children}
          </div>
          {!isBreakpoint && (
            <div className="w-full lg:w-2/5">
              <PatientOrderSummaryOrganism />
              {!includesDrops && (
                <PromoBoxOrganism
                  title={cartPromoBox.title}
                  subtitle={cartPromoBox.subtitle}
                  description={cartPromoBox.description}
                  imageUrl={cartPromoBox.imageUrl}
                  buttonText={cartPromoBox.buttonText}
                />
              )}
              {includesTrial && cart && (
                <PatientSubscriptionSummaryOrganism cart={cart} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
